import styled from '@emotion/styled';

interface MatterportBlockEpsilonProps {
	url: string;
	index?: number;
}

const Wrapper = styled.section`
	padding: 3rem 1.5rem 4rem;
`;

const Title = styled.h2`
	font-size: 2.5rem;
	font-weight: 500;
	text-align: center;
	margin-bottom: 1.5rem;
`;

const Frame = styled.iframe`
	width: 100%;
	aspect-ratio: 16 / 9;
	border: none;
`;

export default function MatterportBlockEpsilon({ url, index }: MatterportBlockEpsilonProps) {
	return (
		<Wrapper id={index == null ? '3d-tour' : undefined}>
			<Title>Virtual Tour</Title>
			<Frame src={url} allowFullScreen allow="xr-spatial-tracking" />
		</Wrapper>
	);
}
